import React from "react";
import DOMPurify from "isomorphic-dompurify";

const RichTextDisplay = ({ content }) => {
  const sanitizedContent = DOMPurify.sanitize(content);

  return (
    <div style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
      <div dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
    </div>
  );
};

export default RichTextDisplay;
